export const driverProfiles = [
  {
    turKodu: "0",
    uyrukUlke: "TR",
    tcKimlikPasaportNo: "13087776324",
    cinsiyet: "E",
    adi: "NIHAT",
    soyadi: "AKGUNDOGDU",
    telefon: "5346135723",
    driverPlate: "34CSR430",
  },
  {
    turKodu: "0",
    uyrukUlke: "TR",
    tcKimlikPasaportNo: "22043690994",
    cinsiyet: "E",
    adi: "HUSNU",
    soyadi: "GUL",
    telefon: "5365623482",
    driverPlate: "34FVM584",
  },
  {
    turKodu: "0",
    uyrukUlke: "TR",
    tcKimlikPasaportNo: "43801514512",
    cinsiyet: "E",
    adi: "YAVUZ",
    soyadi: "HOSAFOGLU",
    telefon: "5395908820",
    driverPlate: "34PBK260",
  },
];
